export const blockIconsPlacesAcUnit = (
	<span className='material-symbols-outlined'>ac_unit</span>
);
